import React from 'react';
import { Button } from '../ui/button';
import { X, Save, Edit } from 'lucide-react';

/**
 * Modal para editar o cabeçalho de impressão dos horários
 */
const HorarioCabecalhoModal = ({
  show,
  cabecalhoEditavel,
  onCabecalhoChange,
  onClose,
  onSave
}) => {
  if (!show) return null;

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
      <div className="bg-card rounded-lg w-full max-w-3xl">
        <div className="p-6 border-b border-border">
          <h2 className="text-xl font-semibold flex items-center gap-2">
            <Edit className="h-5 w-5" />
            Editar Cabeçalho da Impressão
          </h2>
        </div>
        
        <div className="p-6 space-y-4">
          <div>
            <label className="block text-sm font-medium mb-2">
              Texto do Cabeçalho
            </label>
            <p className="text-sm text-muted-foreground mb-2">
              Este texto aparecerá no topo de todas as impressões. 
              Pode usar <code className="bg-muted px-1 rounded">{'${inicio}'}</code> e <code className="bg-muted px-1 rounded">{'${fim}'}</code> para mostrar as datas automaticamente.
            </p>
            <textarea
              value={cabecalhoEditavel}
              onChange={(e) => onCabecalhoChange(e.target.value)}
              rows={8}
              className="w-full p-3 border border-border rounded-lg font-mono text-sm"
              placeholder="Digite o cabeçalho..."
            />
          </div>
          
          <div className="bg-blue-50 border border-blue-200 rounded-lg p-3">
            <p className="text-sm text-blue-800">
              <strong>💡 Dica:</strong> Use quebras de linha para organizar melhor o texto. 
              As variáveis {'${inicio}'} e {'${fim}'} serão substituídas pelas datas do período automaticamente.
            </p>
          </div>
        </div>
        
        <div className="p-6 border-t border-border flex justify-end gap-2">
          <Button 
            variant="outline" 
            onClick={onClose}
          >
            <X className="h-4 w-4 mr-2" />
            Cancelar
          </Button>
          <Button 
            onClick={onSave}
            className="bg-success hover:bg-success/90"
          >
            <Save className="h-4 w-4 mr-2" />
            Guardar
          </Button>
        </div>
      </div>
    </div>
  );
};

export default HorarioCabecalhoModal;
